import { useCallback } from "react";
import { ArrowClockwise, CheckCircle, CloudCheck, Desktop, WarningCircle, XCircle } from "@phosphor-icons/react";
import { Button } from "@radix-ui/themes";

import { useAdminRead } from "../../hooks/useAdminRead";
import { readAdminData } from "../../services/adminApi";

import type { OperationsData } from "../../types";
import type { StatusIconProps } from "./index.types";

const StatusIcon = ({ status }: StatusIconProps) => {
  if (status === "healthy") return <CheckCircle size={22} />;
  if (status === "attention") return <WarningCircle size={22} />;
  return <XCircle size={22} />;
};

export function Operations() {
  const load = useCallback(() => readAdminData<OperationsData>({ view: "operations" }), []);
  const { data, error, isLoading, refresh } = useAdminRead({ load });
  return (
    <main className="page">
      <section className="page-heading"><div><span className="breadcrumb">OPERASYON / SERVİSLER</span><h1>Sistem sağlığı</h1><p>Web, API edge, sayaç ve masaüstü yayın uçlarının istek üzerine alınan durumu.</p></div><div className="snapshot"><Button onClick={() => void refresh()} disabled={isLoading} type="button" variant="soft"><ArrowClockwise size={18} /> Yenile</Button></div></section>
      {error ? <div className="alert danger"><WarningCircle size={21} /><span><strong>Servis durumu yüklenemedi</strong>{error}</span></div> : null}
      <section className="service-grid">
        {data?.services.map((service) => <article className={`service-card status-${service.status}`} key={service.id}><StatusIcon status={service.status} /><div><span>{service.name}</span><strong>{service.status === "healthy" ? "Çalışıyor" : service.status === "attention" ? "Dikkat" : "Kullanılamıyor"}</strong><small>{service.detail}</small></div></article>)}
      </section>
      <section className="panel release-panel"><div className="panel-heading"><div><span className="kicker">MASAÜSTÜ DAĞITIMI</span><h2>Görünür stable sürüm</h2></div><Desktop size={23} /></div><div className="release-summary"><div className="release-version"><CloudCheck size={28} /><span><small>SÜRÜM</small><strong>{data?.desktopRelease.version ?? "—"}</strong><em>Build {data?.desktopRelease.buildNumber ?? "—"}</em></span></div><div><span className="kicker">PLATFORMLAR</span><div className="tag-list">{data?.desktopRelease.platforms.map((platform) => <span key={platform}>{platform}</span>)}</div></div></div></section>
    </main>
  );
}
